t = require('views/internal/teacup-with-helpers')('card_detail_toggle_button')

module.exports = t.renderable ({ isOn, selectorOn, selectorOff, title, text, icon, disabled }) ->
  return if disabled
  classes =
    'button-link toggle-button': true
    'is-on': isOn
    "#{selectorOff}": !isOn
    "#{selectorOn}": isOn
  t.a { class: t.classify(classes), title: t.l(title || text), href: '#' }, ->
    t.icon icon
    t.span ->
      t.format text
    t.span '.on', ->
      t.icon 'check', { class: 'light' }



// WEBPACK FOOTER //
// ./app/scripts/views/templates/card_detail_toggle_button.coffee